import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Back from "../../../components/shared/back";
import Notes from "./tabs-components/notes";
import Expenses from "./tabs-components/expenses";
import JobDetails from "./job-details";
import Users from "./tabs-components/users";
import { getDateRangeUTC } from "../../../utils/set-date-range-utils";
import { getAllJobExpenses, getAllJobNotes, getJobsMinimal, getAllJobUsers, getJob } from "../../../services/jobs-service";
import { AccountsContext } from "../../../components/context/account-context";
import Loader from "../../../components/shared/loader";
import { getAllExpenseCategories, getAllExpensePaymentMethods, getAllExpensesStatuses } from "../../../services/expenses-service";
import { getUsersMinimal, getAllUserStatuses } from "../../../services/users-service";
import Button from "../../../components/shared/custom-btn";
// import DateRangePicker from "../../../components/shared/date-range-picker";
import { IoSearchOutline } from "react-icons/io5";
import Modal from "../../../components/shared/modal";
import ExpensesAddModal from '../../../pages/expenses/add-modal'
import NotesAddModal from '../../../pages/notes/add-modal'
import { getAllVendorsMinimal } from "../../../services/vendors-service";
import Help from './help';
import { usePageHelp } from '../../../components/context/help-context';


const JobView = () => {
    usePageHelp(Help);
    const { accountId, attributes } = useContext(AccountsContext);
    const { jobId } = useParams();
    const [activeTab, setActiveTab] = useState("Expenses");
    const [searchTerm, setSearchTerm] = useState("");
    const [dateRange, setDateRange] = useState({
        startDate: new Date(new Date().setDate(new Date().getDate() - 7)),
        endDate: new Date(),
    });
    const [users, setUsers] = useState([]);
    const [vendors, setVendors] = useState([]);
    const [spenders, setSpenders] = useState([]);
    const [notes, setNotes] = useState([]);
    const [expenses, setExpenses] = useState([]);
    const [expenseStatuses, setExpenseStatuses] = useState([]);
    const [userStatuses, setUserStatuses] = useState([]);
    const [categoryOptions, setCategoryOptions] = useState([]);
    const [paymentOptions, setPaymentOptions] = useState([]);
    const [jobOptions, setJobOptions] = useState([]);
    // const [newlyAddedItem, setNewlyAddedItem] = useState(null);
    const [loading, setLoading] = useState(false);
    const [loadingJob, setLoadingJob] = useState(false);
    const [job, setJob] = useState(null);
    const [jobError, setJobError] = useState(null);
    const [openExpenseAddModal, setOpenExpenseAddModal] = useState(false);
    const [openNoteAddModal, setOpenNoteAddModal] = useState(false);
    const [openUserAddModal, setOpenUserAddModal] = useState(false);
    const [newlyAddedItem, setNewlyAddedItem] = useState(null);

    const [tabStates, setTabStates] = useState({
        Expenses: { loading: false, error: null, dataFetched: false },
        Users: { loading: false, error: null, dataFetched: false },
        Notes: { loading: false, error: null, dataFetched: false },
    });

    const fetchGlobalData = async () => {
        if (!accountId) return;
        setLoading(true);

        try {
            const [usersRes, vendorsRes, categoryRes, paymentRes, jobRes] = await Promise.all([
                getUsersMinimal(accountId),
                getAllVendorsMinimal(accountId),
                getAllExpenseCategories(accountId),
                getAllExpensePaymentMethods(accountId),
                getJobsMinimal(accountId),
            ]);

            if (usersRes.success) setSpenders(usersRes.data.data || []);
            if (vendorsRes.success) setVendors(vendorsRes.data.data || []);
            if (categoryRes.success) setCategoryOptions(categoryRes.data.data || []);
            if (paymentRes.success) setPaymentOptions(paymentRes.data.data || []);
            if (jobRes.success) setJobOptions(jobRes.data.data || []);
        } catch (err) {
            console.error("Failed to fetch global data", err);
            setJob("Failed to fetch global data");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const fetchGlobalData = async () => {
            if (!accountId) return;
            setLoading(true);

            try {
                const [expenseRes, usersRes,] = await Promise.all([
                    getAllExpensesStatuses(accountId),
                    getAllUserStatuses(accountId),
                ]);

                if (expenseRes.success) setExpenseStatuses(expenseRes.data.data || []);
                if (usersRes.success) setUserStatuses(usersRes.data.data || []);
            } catch (err) {
                console.error("Failed to fetch global data", err);
                setJobError("Failed to fetch global data");
            } finally {
                setLoading(false);
            }
        };

        fetchGlobalData();
    }, [accountId]);

    const fetchJob = async () => {
        try {
            setLoadingJob(true);
            const response = await getJob(accountId, jobId);
            console.log(response)
            if (response.success) {
                setJob(response.data.data);
                setJobError(null);
            } else {
                setJobError(response.data.message || "Failed to fetch vehicle details");
            }
        } catch (error) {
            setJobError("An error occurred while fetching vehicle details");
        } finally {
            setLoadingJob(false);
        }
    };

    const fetchTabData = async (tabName) => {
        if (tabStates[tabName]?.loading) return;
        setTabStates((prev) => ({
            ...prev,
            [tabName]: { ...prev[tabName], loading: true, error: null },
        }));

        const { from, to } = getDateRangeUTC(dateRange);
        try {
            let response;
            switch (tabName) {
                case "Expenses":
                    response = await getAllJobExpenses(accountId, jobId);
                    fetchGlobalData();
                    if (response.success) {
                        const sortedData = response.data.data.sort(
                            (a, b) => new Date(b.createdOn) - new Date(a.createdOn)
                        );
                        setExpenses(sortedData);
                        setTabStates((prev) => ({
                            ...prev,
                            Expenses: { loading: false, error: null, dataFetched: true },
                        }));
                    } else {
                        throw new Error(response.data.message || "Failed to fetch expenses records");
                    }
                    break;
                case "Notes":
                    response = await getAllJobNotes(accountId, jobId);
                    console.log("Notes : ", response)
                    // fetchGlobalData();
                    if (response.success) {
                        const sortedData = response.data.data.sort(
                            (a, b) => new Date(b.createdOn) - new Date(a.createdOn)
                        );
                        setNotes(sortedData);
                        setTabStates((prev) => ({
                            ...prev,
                            Notes: { loading: false, error: null, dataFetched: true },
                        }));
                    } else {
                        throw new Error("Failed to fetch notes records");
                    }
                    break;
                case "Users":
                    response = await getAllJobUsers(accountId, jobId);
                    console.log("User Response : ", response)
                    // fetchGlobalData();
                    if (response.success) {
                        const sortedData = response.data.data.sort(
                            (a, b) => new Date(b.createdOn) - new Date(a.createdOn)
                        );
                        setUsers(sortedData);
                        setTabStates((prev) => ({
                            ...prev,
                            Users: { loading: false, error: null, dataFetched: true },
                        }));
                    } else {
                        throw new Error(response.data.message || "Failed to fetch users records");
                    }
                    break;
                default:
                    break;
            }
        } catch (error) {
            setTabStates((prev) => ({
                ...prev,
                [tabName]: {
                    loading: false,
                    error: error.message || `Failed to fetch ${tabName.toLowerCase()} records`,
                },
            }));
        }
    };

    // Effects
    useEffect(() => {
        if (["Expenses", "Notes", "Users"].includes(activeTab)) {
            fetchTabData(activeTab);
        }
    }, [activeTab]);

    useEffect(() => {
        fetchJob();
    }, [accountId, jobId]);


    const TABS = [
        {
            name: "Expenses", component:
                <Expenses
                    data={expenses}
                    loading={tabStates.Expenses.loading}
                    error={tabStates.Expenses.error}
                    setData={setExpenses}
                    jobId={jobId}
                    // newlyAddedItem={newlyAddedItem}
                    // setNewlyAddedItem={setNewlyAddedItem}
                    globalFilter={searchTerm}
                    onGlobalFilterChange={setSearchTerm}
                    accountId={accountId}
                    fetchExpenses={fetchTabData}
                    statusOptions={expenseStatuses}
                    jobsOptions={jobOptions}
                    spendors={spenders}
                    vendors={vendors}
                    categories={categoryOptions}
                    paymentMethods={paymentOptions}
                    attributes={attributes}
                />
        },
        {
            name: "Notes", component:
                <Notes
                    data={notes}
                    loading={tabStates.Notes.loading}
                    error={tabStates.Notes.error}
                    setData={setNotes}
                    jobId={jobId}
                    // newlyAddedItem={newlyAddedItem}
                    // setNewlyAddedItem={setNewlyAddedItem}
                    globalFilter={searchTerm}
                    onGlobalFilterChange={setSearchTerm}
                    accountId={accountId}
                    fetchNotes={fetchTabData}
                    attributes={attributes}
                />

        },
        {
            name: "Users", component:
                <Users
                    data={users}
                    jobId={jobId}
                    loading={tabStates.Users.loading}
                    error={tabStates.Users.error}
                    setData={setUsers}
                    // newlyAddedItem={newlyAddedItem}
                    // setNewlyAddedItem={setNewlyAddedItem}
                    globalFilter={searchTerm}
                    onGlobalFilterChange={setSearchTerm}
                    accountId={accountId}
                    fetchUsers={fetchTabData}
                    statusOptions={userStatuses}
                    attributes={attributes}
                />

        },
    ];

    const handleOpenAddModal = () => {
        switch (activeTab) {
            case "Expenses":
                setOpenExpenseAddModal(true);
                break;
            case "Notes":
                setOpenNoteAddModal(true);
                break;
            case "Users":
                setOpenUserAddModal(true);
                break;
            default:
                break;
        }
    };

    const handleCloseAddModal = () => {
        setOpenNoteAddModal(false);
        setOpenUserAddModal(false);
        setOpenExpenseAddModal(false);
    };

    const handleAddItem = (newItem) => {
        setNewlyAddedItem(newItem);
    };

    const handleOpenEditModal = (item) => {
        setNewlyAddedItem(item);
    };

    const activeTabContent = TABS.find(tab => tab.name === activeTab)?.component || <div className="p-4">No Content Available</div>;

    return (
        <div className="p-4 bg-white min-h-screen relative">
            <Back />

            {/* Header */}
            <div className="bg-white flex flex-col md:flex-row items-start md:items-center w-full justify-between gap-6 mt-4">

                {jobError && (
                    <div className="text-red-600 bg-red-100 px-4 py-2 rounded-md">{jobError}</div>
                )}

                {loadingJob ? (
                    <div className="w-full flex justify-center">
                        <Loader />
                    </div>
                ) : (
                    <JobDetails
                        job={job}
                        jobId={jobId}
                    />
                )}

                {activeTab !== "Users" && (
                    <Button
                        label={`Add ${activeTab}`}
                        className="text-white px-4 !py-1 rounded-lg bg-btnBg"
                        onClick={handleOpenAddModal}
                    />
                )}
            </div>

            {/* Tabs */}
            <div className="mt-6 border-b border-gray-200">
                <nav className="flex overflow-x-auto gap-4 no-scrollbar">
                    {TABS.map((tab) => (
                        <button
                            key={tab.name}
                            onClick={() => setActiveTab(tab.name)}
                            className={`flex items-center justify-between px-1 text-left py-2 text-sm  border-gray-200 
                                ${activeTab === tab.name
                                    ? "border-b-2 border-purple-600 text-purple-600 font-medium"
                                    : "text-gray-600 hover:text-gray-900"
                                }`}
                        >
                            {tab.name}
                        </button>
                    ))}
                </nav>
            </div>

            {(
                <div className="flex gap-3 flex-wrap mt-5">
                    <div className="bg-white rounded-md px-3 flex border border-border items-center gap-2 w-44 lg:w-72 py-1">
                        <IoSearchOutline className="text-gray-500 text-lg" />
                        <input
                            type="text"
                            className="bg-transparent outline-none py-1 w-full text-sm text-gray-700"
                            placeholder="Search"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                    {/* <DateRangePicker onChange={setDateRange} /> */}
                </div>
            )}

            {/* Tab Content */}
            <div className="mt-3">
                <div className=" bg-white">
                    {activeTabContent}
                </div>
            </div>

            <Modal
                isOpen={
                    openNoteAddModal ||
                    openUserAddModal ||
                    openExpenseAddModal
                }
                onClose={handleCloseAddModal}
                modalClass={"xl:w-[40%] lg:w-[45%] md:w-[65%] sm:w-[70%] w-[90%] !px-0"}
            >
                {activeTab === "Expenses" ? (
                    <ExpensesAddModal
                        handleCloseAddModal={handleCloseAddModal}
                        onAdd={handleAddItem}
                        openEditModal={handleOpenEditModal}
                        showVehicle={false}
                        spendors={spenders}
                        vendors={vendors}
                        job={job}
                        fetchExpenses={fetchTabData}
                        isJobTab={true}
                        paymentMethods={paymentOptions}
                        categories={categoryOptions}
                        jobsOptions={jobOptions}

                    />
                ) : activeTab === "Notes" ? (
                    <NotesAddModal
                        handleCloseAddModal={handleCloseAddModal}
                        onAdd={handleAddItem}
                        linkedType={"job"}
                        linkedId={jobId}
                        fetchNotes={fetchTabData}
                        openEditModal={handleOpenEditModal}
                    />
                ) : null}
            </Modal>
        </div>
    );
};

export default JobView;
